export const option_1 = [
  { id: 1, 작업내용: "철거공사", 유해위험요인: "철거공사 중 장비, 철거 잔재물 등\n" + "하중으로 인해 건물 무너짐", 위험성감소대책: "1. 장비, 공법 등이 변경될 경우 재검토 및 안전성 확인\n" + "2. 철거된 잔재물 적재높이 관리" },
  { id: 2, 작업내용: "철거공사", 유해위험요인: "철거공사 전 사전조치 미흡", 위험성감소대책: "1. 작업 전 탈락위험 자재 사전제거\n" + "2. 전기, 가스 사전 공급 차단" },
  {
    id: 3,
    작업내용: "철거공사",
    유해위험요인: "철거 작업 중 석면 비산물의 위험",
    위험성감소대책: "1. 사전 석면조사 실시 및 절차에 따른 석면 해체 및 제거 실시\n" + "2. 작업순서, 안전보호구 착용 감독 방진마스크(특급), 송기마스크, 방진복, 덧신, 보호장갑 등",
  },
  { id: 4, 작업내용: "철거공사", 유해위험요인: "현장 내 개구부 및 단부 떨어짐 방지", 위험성감소대책: "1. 추락 방호망 설치\n" + "2. 개구부 덮개 및 안전난간 설치\n" + "3. 추락주의 표지판 배치" },
  {
    id: 5,
    작업내용: "철거공사",
    유해위험요인: "내장재 해체·제거 중 말비계, 사다리\n" + "이동식 비계 떨어짐 방지조치",
    위험성감소대책: "1. 이동식 사다리 2인1조 작업\n" + "2. 안전모 등 보호구 지급 및 착용\n" + "3. 전도 방지대 등 조치 철저",
  },
  { id: 6, 작업내용: "철거공사", 유해위험요인: "폐기물 운반 시 근로자 맞음 방지", 위험성감소대책: "1. 근로자와 충분한 작업거리 확보\n" + "2. 출입금지 구역 설정" },
  { id: 7, 작업내용: "철거공사", 유해위험요인: "재활용 처리 크레인 운용 시 안전사항", 위험성감소대책: "1. 정격하중 준수 및 넘어짐 방지조치 실시" },
];

export const option_2 = [
  { id: 1, 작업내용: "금속공사", 유해위험요인: "용접작업 중 감전 위험", 위험성감소대책: "1. 작업 전 바닥 물고임 확인\n" + "2. 이동 전선 손상여부 확인\n" + "3. 안전교육 및 보호구 착용 확인" },
  { id: 2, 작업내용: "금속공사", 유해위험요인: "용접작업 중 불티로 인한 화재 위험", 위험성감소대책: "1. 작업 전 불티방지포 보양\n" + "2. 화재감시자 및 소화기 배치\n" + "3. 작업반경 내 인화성 물질 제거" },
  { id: 3, 작업내용: "금속공사", 유해위험요인: "자재 절단 중 부상 위험", 위험성감소대책: "1. 공도구 안전덮개, 접촉방지장치 등 안전장치 확인\n" + "2. 보안경 등 보호구 착용 확인\n" + "3. 말림 위험이 있는 장갑 착용 금지" },
  { id: 4, 작업내용: "금속공사", 유해위험요인: "사다리 및 이동식 작업발판 전도", 위험성감소대책: "1. 발판 폭 40cm 이상 작업발판 사용 및\n" + "2. 작업구간 수시 확인\n" + "3. 발판 단부 낙상경보기 설치" },
  { id: 5, 작업내용: "금속공사", 유해위험요인: "잔여 자재 및 폐기물에 의한 부상", 위험성감소대책: "1. 작업 후 잔여 자재 및 폐기물 처리 철저\n" + "2. 작업 완료구간 정리정돈 철저" },
  { id: 6, 작업내용: "금속공사", 유해위험요인: "상향작업 중 분진 및 파편으로 인한 안구 손상", 위험성감소대책: "1. 상향 작업 시 보안경 지급 및 착용 감독" },
];

export const option_3 = [
  { id: 1, 작업내용: "석재 및 타일공사", 유해위험요인: "전기기계·기구 접지 여부", 위험성감소대책: "1. 누전 감전위험 방지 금속제 외함 접지" },
  { id: 2, 작업내용: "석재 및 타일공사", 유해위험요인: "작업발판 설치 상태", 위험성감소대책: "1. 작업발판 폭 40cm 이상 설치\n" + "2. 탈락방지 위해 2개소 이상 고정" },
  { id: 3, 작업내용: "석재 및 타일공사", 유해위험요인: "자재의 적재방법", 위험성감소대책: "1. 불안정한 높이 적재 금지\n" + "2. 평평하고 단단한 기반 위 적재" },
  { id: 4, 작업내용: "석재 및 타일공사", 유해위험요인: "개구부 추락방지조치 여부", 위험성감소대책: "1. 개구부 안전난간, 덮개 설치\n" + "2. 개구부 표지판 설치\n" + "3. 안전방망 설치" },
  { id: 5, 작업내용: "석재 및 타일공사", 유해위험요인: "자재 운반방법 적절성", 위험성감소대책: "1. 인력운반 시 2인 1조 작업\n" + "2. 1인당 25kg내로 운반할 것\n" + "3. 장비 운반 시 신호수 배치\n" + "4. 운반구간 지정 및 출입통제" },
  { id: 6, 작업내용: "석재 및 타일공사", 유해위험요인: "작업 시 넘어짐 방지 조치", 위험성감소대책: "1. 현장 정리정돈 철저\n" + "2. 근로자 보호구 착용 여부 감독" },
];

export const option_4 = [
  { id: 1, 작업내용: "기계설비 공사", 유해위험요인: "사다리 이용 작업 시 떨어짐 위험", 위험성감소대책: "1. 안전모 필수 착용\n" + "2. 아웃트리거 설치된 사다리 사용\n" + "3. 2인 1조 작업 실시" },
  { id: 2, 작업내용: "기계설비 공사", 유해위험요인: "배관설치 작업 시 말비계 떨어짐 위험", 위험성감소대책: "1. 발판 폭 40cm 이상 확보\n" + "2. 말비계 벌어짐 고정장치 확인" },
  { id: 3, 작업내용: "기계설비 공사", 유해위험요인: "배관절단 작업 위한 핸드그라인더 사용 시 절단 위험", 위험성감소대책: "1. 불티비산방지막 설치\n" + "2. 정품 절단날 확인\n" + "3. 안전덮개 설치여부 확인" },
  { id: 4, 작업내용: "기계설비 공사", 유해위험요인: "이동식 틀비계 이용 시 떨어짐 위험", 위험성감소대책: "1. 상부 구간 안전난간대 설치\n" + "2. 전도방지대 설치 확인\n" + "3. 작업자 탑승 후 이동 금지" },
  { id: 5, 작업내용: "기계설비 공사", 유해위험요인: "A형 사다리 이용한 작업 중 떨어짐, 분진에 의한 상해 위험", 위험성감소대책: "1. 사다리 이용을 지양하고 이동식 비계 등 작업발판 사용\n" + "2. 보안경 및 방진마스크 착용" },
  { id: 6, 작업내용: "기계설비 공사", 유해위험요인: "지지철물 및 배관 떨어짐 위험", 위험성감소대책: "1. 앵커볼트 삽입 깊이, 개수 등 시공상세도 작성 및 준수" },
];

export const option_5 = [
  { id: 1, 작업내용: "도장공사", 유해위험요인: "자재 교반 시 회전 날개에 끼임 사고", 위험성감소대책: "1. 교반 시 자재 내부 촉수 금지\n" + "2. 공도구 정지 전까지 접촉금지" },
  {
    id: 2,
    작업내용: "도장공사",
    유해위험요인: "자재반입 하역, 운반 시 맞음, 넘어짐, 충돌 및 협착",
    위험성감소대책: "1. 인력운반 시 인당 25kg 초과금지\n" + "2. 운반구간 정리정돈 철저\n" + "3. 장비 사용 시 신호수 배치\n" + "4. 장비 이동 구간 내 접근금지",
  },
  { id: 3, 작업내용: "도장공사", 유해위험요인: "환기 불량 호흡보호구 미착용으로 인한 질식사고", 위험성감소대책: "1. 환기설비 설치 및 방진, 방독마스크 등 개인보호구 착용" },
  { id: 4, 작업내용: "도장공사", 유해위험요인: "말비계 사용 작업 시 떨어짐 위험", 위험성감소대책: "1. 말비계 높이 120cm이하로 작업" },
  { id: 5, 작업내용: "도장공사", 유해위험요인: "페인트 믹서기, 컴프레셔 등 공도구 사용 중 감전", 위험성감소대책: "1. 작업 전 공도구 점검 실시\n" + "2. 접지선과 누전차단기 사용" },
  { id: 6, 작업내용: "도장공사", 유해위험요인: "고소작업대 이용 도장작업 중 떨어짐 위험", 위험성감소대책: "1. 작업계획서 작성 및 준수\n" + "2. 탑승자 안전대 지급 및 착용" },
  { id: 7, 작업내용: "도장공사", 유해위험요인: "시너, 페인트 등 보관장소 인근 화기작업으로 인한 \n" + "화재·폭발 위험", 위험성감소대책: "1. 자재는 별도의 장소에 보관\n" + "2. 작업 시 점화원과 최소 10m 이상 격리된 장소에서 실시" },
];

export const option_6 = [
  { id: 1, 작업내용: "전기공사", 유해위험요인: "배전반 고정 및 지지상태 불량으로 넘어짐 위험", 위험성감소대책: "1. 배전반 하단 고정 및 지지 철저" },
  { id: 2, 작업내용: "전기공사", 유해위험요인: "배전반 단락, 지락, 누전에 의한 감전 등 사고위험", 위험성감소대책: "1. 빗물 유입 여부 확인\n" + "2. 개방 부분이 없는 폐쇄형 외함\n" + "3. 금속제 외함에 접지공사 실시" },
  { id: 3, 작업내용: "전기공사", 유해위험요인: "근로자 임의 조작 시 감전", 위험성감소대책: "1. 전기설비 담당자 지정\n" + "2. 조작 시 절연보호구 착용" },
  { id: 4, 작업내용: "전기공사", 유해위험요인: "현장 바닥 전선 피복손상으로 감전", 위험성감소대책: "1. 전선걸이대 사용\n" + "2. 작업 방해가 가장 적은 위치로 배치" },
  { id: 5, 작업내용: "전기공사", 유해위험요인: "전기기계·기구 누전차단기 미설치로 인한 감전", 위험성감소대책: "1. 콘센트에 누전차단기 연결\n" + "2. 작업 시작 전 누전차단기 확인\n" + "3. 가급적 이중 절연구조 공구 사용" },
  { id: 6, 작업내용: "전기공사", 유해위험요인: "작업구간 조명설비 불량으로 넘어짐 위험", 위험성감소대책: "1. 작업 종류에 따른 조도 확보(보통작업 150lux)" },
  { id: 7, 작업내용: "전기공사", 유해위험요인: "바탕면 정리 시 비산먼지로 인한 호흡기질환 우려", 위험성감소대책: "1. 방진마스크 및 보안경 등 개인보호구 착용 확인" },
];

export const option_7 = [
  { id: 1, 작업내용: "조적·미장방수공사", 유해위험요인: "시멘트 혼합 작업 시 보호구 및 기계 점검", 위험성감소대책: "1. 방진 마스크 등 개인보호구 착용\n" + "2. 이동전선 1.5m이상 높이설치\n" + "3. 접지 및 누전차단기 연결확인" },
  { id: 2, 작업내용: "조적·미장방수공사", 유해위험요인: "이동식비계 상부 작업 중 떨어짐 위험", 위험성감소대책: "1. 근로자 탑승상태 이동금지\n" + "2. 누락구간 없이 작업발판 설치\n" + "3. 아웃트리거 설치로 넘어짐 방지" },
  { id: 3, 작업내용: "조적·미장방수공사", 유해위험요인: "인화성, 가연성 자재 화재위험", 위험성감소대책: "1. 화기사용 엄금\n" + "2. 소화기 비치" },
  { id: 4, 작업내용: "조적·미장방수공사", 유해위험요인: "방수작업 중 유독가스 및 산소부족으로 인한 질식위험", 위험성감소대책: "1. 밀폐공간인 경우 환기시설 설치\n" + "2. 단독작업 금지\n" + "3. 주기적 산소, 가스농도 측정" },
];

export const option_8 = [
  { id: 1, 작업내용: "수장공사", 유해위험요인: "자재 반입 시 하역기계와 충돌, 협착", 위험성감소대책: "1. 운반 작업 시 신호수 배치\n" + "2. 운반구간 표시(라바콘 등)" },
  { id: 2, 작업내용: "수장공사", 유해위험요인: "자재 가공 시 분진 및 소음으로 인한 근로자 질병 발생 우려", 위험성감소대책: "1. 환풍기 등 환기시설 설치\n" + "2. 방진마스크, 귀마개 착용 감독" },
  { id: 3, 작업내용: "수장공사", 유해위험요인: "접착제 등 위험물질 사용으로 인한 근로자 질병 발생 우려", 위험성감소대책: "1. 물질안전보건자료(MSDS) 비치\n" + "2. 경고표지 부착, 안전교육 실시" },
  { id: 4, 작업내용: "수장공사", 유해위험요인: "불량 발판 사용으로 인한 떨어짐 위험", 위험성감소대책: "1. 안정성이 확보된 작업발판 사용\n" + "2. 작업공간 내 위험요인 확인\n" + "3. 와이어, 클립 등 안전장치 확인" },
  { id: 5, 작업내용: "수장공사", 유해위험요인: "불연속 발판, 사다리 사용으로 떨어짐 위험", 위험성감소대책: "1. 천장용 작업발판 설치\n" + "      (바닥 전체 작업발판 설치 각각 2개소 이상 고정)" },
  { id: 6, 작업내용: "수장공사", 유해위험요인: "고정 불량으로 인한 자재 맞음 위험", 위험성감소대책: "1. 전동드릴 사용한 나사못 고정 철저" },
  { id: 7, 작업내용: "수장공사", 유해위험요인: "타정총 및 타카건 사용 시 부주의로 인한 상해", 위험성감소대책: "1. 사용 시 관리자 지명\n" + "2. 신체를 향해 사용 금지\n" + "3. 이동 시 잠금장치 사용" },
];

export const option_9 = [
  { id: 1, 작업내용: "통신공사", 유해위험요인: "자재반입 시 CD관 하차 중 배관자재에 걸려 넘어져 단부측으로 추락할 위험", 위험성감소대책: "1. 배관자재 등 주변정리 실시\n2. 기존자재 등 고정철저히 한후 작업실시" },
  { id: 2, 작업내용: "통신공사", 유해위험요인: "입선작업 중 케이블 당김신호를 파악하지 못한 상태에서 케이블을 풀어 구조물과 충돌", 위험성감소대책: "1. 작업 전 신호체계 확립\n2. 원거리 작업 시 무전기 등 활용" },
  { id: 3, 작업내용: "통신공사", 유해위험요인: "케이블 드럼의 갑작스런 이동으로 인한 절단작업 중 근로자 협착", 위험성감소대책: "1. 케이블 드럼의 불시이동 방지\n      - 고임목(2조), 고정대(1조) 확보\n      - 경사로 구간 내 적치 금지" },
];
